import { useState, useRef, useCallback } from 'react';
import { CreateAccountPageContent } from '../pages/onboarding/CreateAccountPageContent';
import { useAccountSelectionApiFacade } from '../../apis/facades/useAccountSelectionApiFacade';
import { createAccountUrl } from './utils';
import { useNavigate } from 'react-router';
import { useAccountSelectionContext } from './AccountSelectionContext';
import { telemetry } from '../../telemetry';

export const AccountSelectionCreateAccount = ({ onGoBack }: { onGoBack?: () => void }) => {
  const [fullName, setFullName] = useState<string | undefined>('');
  const [accountName, setAccountName] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const accountField = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();
  const { post_account } = useAccountSelectionApiFacade();
  const { openAccountSelection } = useAccountSelectionContext();

  const isFormValid = !!accountName;

  const onClick = useCallback(async () => {
    setIsSubmitting(true);
    setIsSubmitted(true);
    if (!isFormValid) {
      setIsSubmitting(false);
      if (!accountName && accountField?.current) {
        accountField.current.focus();
      }
      return;
    }

    try {
      const response = await post_account({ name: accountName });
      window.location.href = createAccountUrl(response.authZeroOrgId, fullName, true);
    } catch (error) {
      telemetry.captureError(error);
    } finally {
      setIsSubmitting(false);
    }
  }, [post_account, accountName, fullName, isFormValid]);

  return (
    <CreateAccountPageContent
      title="Create an Account"
      goBack={() => {
        if (onGoBack) {
          onGoBack();
        } else {
          navigate(-1);
          openAccountSelection();
        }
      }}
      fullName={fullName}
      setFullName={setFullName}
      accountName={accountName}
      setAccountName={setAccountName}
      isSubmitting={isSubmitting}
      isSubmitted={isSubmitted}
      onClick={onClick}
      accountField={accountField}
    />
  );
};
